export const ICON_NAMES = [
  'Add_Plus',
  'Add_To_Queue',
  'Arrow_Left',
  'Arrow_Left_Right',
  'Arrow_Left_SM',
  'Arrow_Up_LG',
  'Arrow_down',
  'Arrows_Reload',
  'Bell',
  'Bell_Notification_Fill',
  // Book_Open — наша добавка к pack-у фронтендера (Figma → Правила в MenuList).
  // Не присутствует в оригинальном mcms-front/src/assets/icons/packs/serious.
  'Book_Open',
  'Burger',
  'Calendar',
  'Car_Auto',
  'Caret_Circle',
  'Caret_Down_Little',
  'Chart_Bar',
  'Chart_Line',
  'Chat_Conversation',
  'Check',
  'Check_All_Big',
  'Check_Big',
  // Check_Double — наша добавка (Lucide check-check): вторая галочка «прочитано»
  // у сообщений в тикетах (вид 'split', telecom). В паки serious и wap положена
  // та же копия — их виды тикетов её не зовут.
  'Check_Double',
  'Checkbox_Off',
  'Checkbox_On',
  'Chevron',
  'Chevron_Down',
  'Circle_Help',
  'Clock',
  'Close',
  'Cloud_Download',
  'Coin',
  'Copy',
  'Dashboard',
  'EUR',
  'External_Link',
  'Eye',
  'File_Document',
  'Files',
  'Filter',
  // Help_Book — иконка пункта «Помощь» в меню. Отдельное имя, а не Circle_Help:
  // тот занят статусами («неизвестный статус» в Выплатах, «право собственности
  // не подтверждено» в Источниках), где нужен именно вопросительный знак.
  // В паке serious лежит копия его Circle_Help — вид кабинета не меняется.
  'Help_Book',
  'Image',
  'Loading',
  'Landing',
  'Log_Out',
  'Mail',
  'Money',
  'More_Horizontal',
  // Сеть из трёх узлов — пункт «IP-адреса» в меню telecom (Lucide-контур); в serious и
  // wap тот же рисунок тонкой обводкой, в их меню не показывается.
  'Network',
  'One_Circle',
  'Pen',
  'Plus',
  // Qr_Code — пункт меню «PWA» (21.09.2026). В паке wap пока копия
  // serious-иконки: имя из ICON_NAMES обязано быть в обоих паках, иначе сборка
  // второго бренда падает белым экраном на инициализации iconRegistry.
  'Qr_Code',
  'RUB',
  // Repeat — режим показа лендингов «по кругу» (StreamBadges). Отдельное имя, а
  // не Arrows_Reload: тот занят кнопками перезапроса в статистике и тикетах, и
  // подмена его файла сломала бы их. В serious-паке лежит копия прежней
  // Arrows_Reload — там индикатор режима не менялся.
  'Repeat',
  'Return_Back',
  // Scales — режим показа лендингов «Балансировка» (StreamBadges, карточки режима в форме
  // потока): весы с наклоном — лидер получает больше трафика. Своя манера в каждом паке:
  // serious — контур 1.2 на сетке 20, telecom — Lucide-контур 2, wap — заливка.
  'Scales',
  // Search — лупа в поле поиска (список потоков telecom, Lucide). В паках
  // serious и wap — та же обводка: имя обязано быть во всех паках.
  'Search',
  'Select_Multiple',
  'Settings',
  'Shopping_Cart',
  'Sort_Ascending',
  'Sort_Descending',
  'Split',
  // Star — заголовок секции «Топ лендингов» на дашборде (Figma «Interface / Star»).
  // В паке wap пока лежит копия serious-иконки: дашборда у wapclick нет, но имя из
  // ICON_NAMES обязано быть в обоих паках — иначе сборка второго бренда падает белым
  // экраном ещё на инициализации iconRegistry. Заменить на свою при дашборде wapclick.
  'Star',
  'Stop_Sign',
  'Tooltip_Info',
  'Trash',
  'USD',
  'Unfold_More',
  'User_Big',
  'User_Voice',
  'Users',
  'Users_Group',
  'Warning',
  'WarningWaveFill',
  'notifications_Check',
] as const;

export type IconName = (typeof ICON_NAMES)[number];

export const ICON_COLORS = [
  'currentColor',
  'primary',
  'primaryDisabled',
  'black',
  'white',
  'blue',
  'lightBlue',
  'orange',
  'violet',
  'yellow',
  'pink',
  'green',
  'gray',
  'bordo',
  'red',
] as const;

export type IconColor = (typeof ICON_COLORS)[number];
